module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bOfqJ"))).then(() => parcelRequire('d0iPb'));